import type { ReactNode } from 'react';

/** The standard page header (mirrors the desktop's, shared design system). */
export function PageHead({ crumb, title, lead }: { crumb: string; title: string; lead: ReactNode }) {
  return (
    <div className="pagehead">
      <div className="crumb">{crumb}</div>
      <h1>{title}</h1>
      <p className="lead">{lead}</p>
    </div>
  );
}
